import { Component, OnInit } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { environment } from './../environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { filter } from 'rxjs/operators'
import { LanguageService } from './shared/services/language.service'
import Cookies from 'js-cookie'

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public title = 'My Classroom Economy'
  public environment = environment

  constructor(
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly languageService: LanguageService
  ) { }

  ngOnInit() {
    // Set English as the fallback for missing translation keys.
    // The active language is set by LanguageGuard on every navigation.
    this.translate.setFallbackLang('en');
    Cookies.remove('lang', { sameSite: 'strict' });

    // After every client-side navigation the router renders a fresh component
    // whose .english/.spanish elements start in their default HTML state.
    // Re-apply the current language's visibility toggles once the new DOM exists.
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const lang = this.translate.getCurrentLang() || 'en';
      this.languageService.applyLanguageVisibility(lang);
    });
  }
}
